import * as React from "react";
import { useEffect, useState } from "react";
import styles from "./Stats.module.css";

function Stats() {
  const [stats, setStats] = useState([]);

  useEffect(() => {
    fetch("stats/btcstats")
      .then((resp) => resp.json())
      .then((data) => {
        setStats(data);
      })
      .catch((err) => console.log(err.message));
  }, []);

  const usdFormat = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
  });

  const commaFormat = new Intl.NumberFormat();

  return (
    <div className={`${styles.stats} mbox`}>
      <h4 title="Basic Bitcoin (BTC) statistics">
        <img src="/img/BTC64.png" alt="btc CC4 by sebbo117" />
        <span className="m-2"> Bitcoin (BTC) </span>
        
        {isNaN(stats.market_price_usd) && (
          <span></span>
        )}
        
        {!isNaN(stats.market_price_usd) && (
          <span className={styles.price}>
            {usdFormat.format(stats.market_price_usd)}
          </span>
        )}
          
      </h4>
      <h6 className={`${styles.pricechange} text-center`}>
        Market Price Change (24h):
        <span>{stats.market_price_usd_change_24h_percentage} %</span>
      </h6>
      <hr />
      <table className={`${styles.tbl}`}>
        <tbody>
        <tr>
          <th>Block Height: </th>
          <td>{stats.blocks}</td>
        </tr>
        <tr>
          <th>Lastest Block Time: </th>
          <td style={{ fontSize: 11 }}>{stats.best_block_time} (UTC)</td>
        </tr>
        <tr>
          <th># of Transactions: </th>
          <td>{stats.transactions_24h} (per day)</td>
        </tr>
        <tr>
          <th>Hash Rate: </th>
          <td>{stats.hashrate_24h} (EH/s)</td>
        </tr>
        <tr>
          <th>Difficulty: </th>
          <td>{stats.difficulty} (trillion)</td>
        </tr>
        <tr>
          <th>Circulating Supply: </th>
          <td style={{ fontSize: 11 }}>
            {commaFormat.format(stats.circulation)} BTC ({stats.circulationPct}
            %)
          </td>
        </tr>
        <tr>
          <th>Total Supply: </th>
          <td style={{ fontSize: 11 }}>21,000,000 BTC</td>
        </tr>
        </tbody>
      </table>
      <div style={{ fontSize: 11, marginTop: 8 }}>source: blockchair</div>
    </div>
  );
}

export default Stats;
